export function formatPrice(value: number, digits = 2): string {
  return value.toLocaleString("zh-CN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatSigned(value: number, digits = 2): string {
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toFixed(digits)}`;
}

export function formatPercent(value: number, digits = 2): string {
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toFixed(digits)}%`;
}

export function formatCompact(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return value.toLocaleString("zh-CN");
}

export function directionClass(value: number): string {
  if (value > 0) return "text-rose-600";
  if (value < 0) return "text-emerald-600";
  return "text-foreground-500";
}

export function directionBadge(value: number): string {
  if (value > 0) return "bg-rose-50 text-rose-600 border-rose-100";
  if (value < 0) return "bg-emerald-50 text-emerald-600 border-emerald-100";
  return "bg-background-100 text-foreground-500 border-background-200";
}

export function trendColor(value: number): string {
  if (value > 0) return "#e11d48";
  if (value < 0) return "#059669";
  return "#8a8578";
}